import React, {Component} from 'react';
import PropTypes from 'prop-types'
import {withRouter} from 'react-router'
import ActionLink from "../controls/ActionLink";
import {Token, UserContext} from "../auth/Auth";

class AccountMenu extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };
    static defaultProps = {};
    state = {};

    render() {
        const userContext = UserContext.get();
        if (userContext == null)
            return (
                <li id="account-menu">
                    <ActionLink onClick={() => this.signIn()}>
                        Войти
                    </ActionLink>
                </li>
            );

        return (
            <li className="dropdown" id="account-menu">
                <a href="#" className="dropdown-toggle" role="button" data-toggle="dropdown">
                    <span className="hidden-md">{userContext.userPhoneNumber}</span>
                </a>
                <ul className="dropdown-menu">
                    {/*<li>*/}
                    {/*<Link to="/profile">*/}
                    {/*<i className="fa fa-user"/> Учётная запись*/}
                    {/*</Link>*/}
                    {/*</li>*/}
                    {/*<li className="divider"/>*/}
                    <li>
                        <ActionLink onClick={() => this.signOut()}>
                            <i className="dropdown-icon fa fa-power-off"/>&nbsp;&nbsp;Выйти
                        </ActionLink>
                    </li>
                </ul>
            </li>
        );
    }

    signIn() {
        this.props.history.push('/login');
    }

    signOut() {
        UserContext.reset();
        Token.reset();

        this.props.history.push('/login');
    }
}

export default withRouter(AccountMenu);


// WEBPACK FOOTER //
// ./src/components/AccountMenu.js